import React, { Component } from "react";
import { Text } from '../../../v2SPRINTA/atoms/Form'

export default class SimpleSlider extends Component {

    componentDidMount() {
        this.refs.t.setError("OOOOO")
    }

    render() {
        return (
            <div style={{ padding: '30px' }}>
                <Text ref='t' label='Com grandes poderes, temos grandes responsabilidades' />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/App/pages/Dev/index.js